import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcuser.ticketing.list');
import { OnInit, OnDestroy, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { TicketList } from "src/libs/ticket-list";

@Component({
    selector: 'wiz-portal-gsdcuser-ticketing-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcuser.ticketing.list/view.scss */
/* src/app/portal.gsdcuser.ticketing.list/view.scss: no such file or directory */`],
})
export class PortalGsdcuserTicketingListComponent extends TicketList implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) {
        super(params => wiz.call('load', params), () => service.render(), 'sent');
    }

    @Input() ticketing_id: any;

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, '/login');
        this.setStatusFromUrl(this.router.url);
        await this.load();
    }

    public ngOnDestroy() { this.dispose(); }
}

export default PortalGsdcuserTicketingListComponent;